<template>
  <v-container grid-list-xs class="pa-2">
    <v-layout row wrap>
       <v-flex :class="toolClass">
        <v-btn icon class="ma-0" :title="$t('add-note')" v-if="!locked" @click="addNote">
          <v-icon>note_add</v-icon>
        </v-btn>
        <v-chip small label outlined :color="chipColor">IDX {{ index }}</v-chip>
      </v-flex>
      <v-flex :class="labelClass">
        {{ translatedLabel }}
      </v-flex>
      <v-flex :class="inputClass">
        <v-layout row>
          <v-flex shrink class="pr-4">
            <v-checkbox v-model="yes" :label="$t('yes')" :disabled="locked" class="mt-0"></v-checkbox>
          </v-flex>
          <v-flex shrink class="pr-4">
            <v-checkbox v-model="no" :label="$t('no')" :disabled="locked" class="mt-0"></v-checkbox>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 order-xs4 v-if="translatedDescription">
        <p><v-icon small>info</v-icon> {{ translatedDescription }}</p>
      </v-flex>
      <v-flex xs12 order-xs5 :style="noteStyle">
        <v-textarea
          v-model="note"
          :label="$t('note')"
          :disabled="locked"
          rows="1"
          auto-grow
          clearable
        ></v-textarea>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import validationMixin from './checklist-input-validation-mixin.es6'
import translationMixin from './checklist-translation-mixin.es6'
import noteMixin from './checklist-note-mixin.es6'

export default {
  name: 'checklist-input-switch',
  mixins: [validationMixin, translationMixin, noteMixin],
  props: {
    index: Number,
    label: String,
    description: String,
    validations: Array,
    default: Object,
    length: String
  },
  data () {
    // initial state
    return {
      yes: null,
      no: null
    }
  },
  created () {
    const { value, note } = this.default
    // set default value
    if ((/boolean/).test(typeof value)) {
      this.yes = value
      this.no = !value
    }
    // set user note
    if ((/string/).test(typeof note)) {
      this.note = note
    }
  },
  computed: {
    value () {
      return (this.yes === true) ? true : (this.no === true) ? false : null
    },
    valid () {
      if (this.validations.length === 0) {
        return true
      }

      let { value } = this
      if ((/boolean/).test(typeof value)) {
        const { valid } = this.validate(value)
        return valid
      }

      return true
    },
    locked () {
      return this.$store.getters['checklist/isLocked']
    },
    toolClass () {
      const { breakpoint } = this.$vuetify
      if (this.length === 'narrow') {
        return {
          'text-right grey--text text--darken-2': true,
          'xs12': true
        }
      } else {
        return {
          'text-right grey--text text--darken-2': true,
          'shrink': breakpoint.mdAndUp,
          'xs12': breakpoint.xs,
          'sm6': breakpoint.sm,
          'order-xs1': breakpoint.xs,
          'order-sm2': breakpoint.sm,
          'order-md3': breakpoint.mdAndUp
        }
      }
    },
    labelClass () {
      const { breakpoint } = this.$vuetify
      if (this.length === 'narrow') {
        return {
          'subtitle-1 pt-2': true,
          'xs12': true
        }
      } else {
        return {
          'subtitle-1 mt-3 pt-1': true,
          'grow': breakpoint.mdAndUp,
          'xs12': breakpoint.xs,
          'sm6': breakpoint.sm,
          'order-xs2': breakpoint.xs,
          'order-sm1': breakpoint.sm,
          'order-md2': breakpoint.mdAndUp
        }
      }
    },
    inputClass () {
      const { breakpoint } = this.$vuetify
      if (this.length === 'narrow') {
        return {
          'xs12 mt-2': true
        }
      } else {
        return {
          'mt-2 pt-2': true,
          'shrink': breakpoint.mdAndUp,
          'xs12': breakpoint.xs,
          'sm12': breakpoint.sm,
          'order-xs3': breakpoint.xs,
          'order-sm3': breakpoint.sm,
          'order-md1': breakpoint.mdAndUp
        }
      }
    }
  },
  watch: {
    yes (value) {
      if (value === true) {
        this.no = false
      }
      this.$emit('value', {
        value: this.value,
        valid: this.valid
      })
    },
    no (value) {
      if (value === true) {
        this.yes = false
      }
      this.$emit('value', {
        value: this.value,
        valid: this.valid
      })
    },
    default: {
      handler ({ value, note }) {
        if (value === true) {
          this.yes = true
        }
        if (value === false) {
          this.no = true
        }
        if (note !== null) {
          this.note = note
        }
      },
      deep: true
    }
  }
}
</script>
